import React from 'react';
import Field from '../Suggest/Field';
import pin from './pin.png';
import { Wrapper, Icon, Title, Theme } from './styles';

export default function Suggest(props) {
	return <>
		<Title>
			Jak {props.meta.count < 100 ? 'probíhají' : 'dopadly'} volby u Vás?
		</Title>
		<Wrapper>
			<Icon src={pin} width="14" height="20" />
				&nbsp;
			<Field rootUrl={props.rootUrl} onSelect={props.onSelect} theme={Theme} limit={9} />
		</Wrapper>
	</>;
}

Suggest.defaultProps = {
	meta: {
		count: 0
	}
};
